import { Select, SelectProps } from "antd";

export default function LocalePicker(props: SelectProps) {
  const localeOptions = [
    { value: "nl_NL", label: "🇳🇱 Nederlands (Nederland)" },
    { value: "nl_BE", label: "🇳🇱 Nederlands (België)" },
    { value: "fr_BE", label: "🇫🇷 Frans (België)" },
  ];

  return <Select {...props} options={localeOptions} />;
}
